<div class="full-page-image-header" [ngStyle]="getHeaderBackground()">
  <div class="header-content">
    @for (topic of topics; track topic; let last = $last) {
      <a class="topic" href="./topic/{{ topic.url }}"
        >{{ topic.name }}@if (!last) {
        <span>, </span>
        }</a
        >
      }
      <h1>{{ title }}</h1>
      <h2>{{ description }}</h2>
    </div>
    @if (!hideArrow) {
      <i class="fas fa-chevron-down"></i>
    }
  </div>
